import React, { memo } from "react";
import { Controller } from "react-hook-form";
import RequiredTitle from "./RequiredTitle";

const CheckboxField = ({ input, control, error, defaultValue }) => {
  const { name, type, label, validation, alignment = {}, defaultValues = defaultValue, ...rest } = input;
  const { sm = 12, md = 12, lg = 12 } = alignment;

  return (
    <div
      key={name}
      className={`form-group mb-3 col-sm-${sm} col-md-${md} col-lg-${lg}`}
    >
      <RequiredTitle
        label={label}
        validation={validation}
      />
        <Controller
          name={name}
          control={control}
          rules={validation}
          defaultValue={defaultValues}
          render={({ field }) => (
            <>
              <input
                id={name}
                type="checkbox"
                checked={field.value || false}
                onChange={(e) => field.onChange(e.target.checked)}
                className={`form-check-input ${error ? "is-invalid" : ""}`}
                {...rest}
              />
              {error && <div className="invalid-feedback">{error}</div>}
            </>
          )}
        />
    </div>
  );
};

export default memo(CheckboxField);
